<template>
    <div class="role-resource">
<!--        <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--            <el-breadcrumb-item>系统管理</el-breadcrumb-item>-->
<!--            <el-breadcrumb-item :to="{ path: '/t/sys/role/' }">角色管理</el-breadcrumb-item>-->
<!--            <el-breadcrumb-item>角色权限管理</el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
        <el-main v-loading="loading" class="pageMain">
            <div class="fixedHeader">
                <span v-if="role">{{role.name}}-</span>权限管理
                <div class="rightBox">
                    <el-button size="mini" type="primary" @click="save()" class="btnStyle">保存</el-button>
                    <el-button size="mini" @click="closePage()" class="btnStyle">返回</el-button>
                </div>
            </div>
<!--            <el-row class="el-row" justify="space-between">-->
<!--                <el-col :span="12">-->
<!--                    <el-page-header v-if="loaded" @back="goBack" :content="role.name">-->
<!--                    </el-page-header>-->
<!--                </el-col>-->
<!--                <el-col :span="12" style="text-align: right">-->
<!--                    <el-button-->
<!--                            @click="save()"-->
<!--                            style="margin-left:15px;"-->
<!--                            class="addBtn"-->
<!--                            type="primary"-->
<!--                            size="mini"-->
<!--                            round-->
<!--                            icon="el-icon-document-add"-->
<!--                            v-if="loaded"-->
<!--                    >保存-->
<!--                    </el-button>-->
<!--                </el-col>-->
<!--            </el-row>-->
            <div style="margin-top:10px;" v-if="loaded">
                <el-card class="box-card" :key="m.id" v-for="m in modules">
                    <div slot="header" class="clearfix">
                        {{m.name}}
                        <el-checkbox style="float: right;" v-model="m.checkedAll" @change="updateCheck(m,'tree_' + m.id)">全选</el-checkbox>
                    </div>
                    <div class="representBox" v-if="m.resources">
                        <el-tree
                                :ref="'tree_' + m.id"
                                node-key="id"
                                :default-checked-keys="m.checkedKeys"
                                :show-checkbox="true"
                                :props="treeProps"
                                style="vertical-align: top;"
                                :data="m.resources"
                                :default-expand-all="true">
                        </el-tree>
                    </div>
                </el-card>
            </div>
        </el-main>
    </div>
</template>

<script>
    import {roleApi, moduleApi, moduleResourceApi} from "@/api/organization";
    import utils from "@/common/utils";
    import {userApi} from "../../api/organization";
    import {mapMutations} from "vuex";

    export default {
        name: "Sys_Role_Resource",
        data(){
            return {
                roleId:0,
                role:null,
                modules:null,
                resources:null,
                roleResources:null,
                loading:true,
                loaded: false,
                treeProps:{
                    label: "displayName",
                    children: 'children'
                },
                userData:{},
            }
        },
        created() {
            this.roleId = this.$route.params.id;
            this.userData = this.$store.state.AuthedUser;
            this.initPage();
        },
        methods:{
            ...mapMutations(["changeLogin", "changeUserRight"]),
            updateCheck(module, treeId){
                const tree = this.$refs[treeId][0];
                if(module.checkedAll){
                    tree.setCheckedNodes(module.resources);
                } else {
                    tree.setCheckedKeys([]);
                }
            },
            goBack(){
                this.$root.$emit('closeTabs',this.$route.path);
            },
            alertAndBack(msg){
                this.$alert(msg)
                    .then(()=>{
                        //后退
                        this.goBack();
                    });
            },
            initPage(){
                roleApi.get(this.roleId)
                    .then(r => {
                        if(r.data.result === 0){
                            this.role = r.data.data;

                            //加载可分配的学校模块
                            moduleApi.list()
                                .then(r1 => {
                                    if(r1.data.result === 0){
                                        const ms = r1.data.data;
                                        this.modules = [];
                                        for(const m of ms){
                                            this.modules.push(Object.assign({}, m, {checkedKeys:[], checkedAll:false, resources:[]}))
                                        }
                                    } else {
                                        this.alertAndBack("调用接口失败");
                                    }
                                })

                            // 获取当前可分配的（用户所在学校）的全部权限
                            moduleResourceApi.listAll({roleType: this.role.type.value,
                                roleIds:this.userData.roleId,

                            })
                                .then(r => {
                                    if(r.data.result === 0){
                                        this.resources = r.data.data;
                                    } else {
                                        this.alertAndBack("获取学校模块信息失败:" + r.data.message);
                                    }
                                })

                            // 获取当前角色的权限列表
                            roleApi.listRights({ids:this.role.id})
                                .then(r => {
                                    if(r.data.result === 0){
                                        this.roleResources = r.data.data;
                                    }
                                })
                        } else {
                            this.alertAndBack("获取角色信息失败:" + r.data.message);
                        }
                    });

                this.initData();
            },
            initData(){
                if(this.role != null
                    && this.modules != null
                    && this.resources != null
                    && this.roleResources != null){

                    for(let i=0;i<this.modules.length;i++){
                        const m = this.modules[i];
                        m.resources = utils.toTree(this.resources.filter(r => r.moduleId === m.id));
                        m.checkedKeys = this.roleResources.map(r => r.resourceId);
                    }

                    this.loading = false;
                    this.loaded = true;
                } else {
                    setTimeout(this.initData, 100);
                }
            },
            save(){
                const rights = [];
                this.modules.forEach(m => {
                    const tree = this.$refs['tree_' + m.id][0];
                    rights.push(tree.getCheckedKeys());
                })

                this.loading = true;
                roleApi.saveRights(this.roleId, rights)
                    .then(r => {
                        this.loading = false;
                        if(r.data.result === 0){
                            this.$message.success("保存成功");
                            this.listUserRights(0);
                        }
                    }).catch(()=>{this.loading=false;})
            },
            listUserRights(pageType){
                userApi.listUserRights(pageType).then(r => {
                    if(r.data.result == 0){
                        const rData = r.data.data;
                        this.changeUserRight(rData);
                        this.closePage();
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .role-resource {
    .el-main {
        min-height:300px;

    .submitBox {
        margin-bottom: 10px;
    }

    .box-card {
        width: 280px;
        display: inline-block;
        margin: 10px;
        vertical-align: top;


    .el-card__body {
        padding: 15px 20px;
    }

    }
    }}
</style>
